import styled from 'styled-components';

export const StyledTodo = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  padding: 12px 0;
  margin: 0 12px;
`;

export default {};
